module.exports = __webpack_public_path__ + "img/kou_02.89244a58.png";